import React from 'react';

const MobileApp = () => {
    return (
        <section className="payback-section container mx-auto mb-10">
		<div className="">
            
			<div className="hero-content  lg:flex-row flex-col max-w-full items-center p-0 justify-around">
            
                
				<div className="w-5/12 py-20">
					<h3 className="text-3xl py-2 w-80 font-bold text-white">
                    DOWNLOAD APP &
                    GET THE VOUCHER!
					</h3>
                    <p className="py-2 w-80 text-white">
                    Get 30% off for first transaction using
Rondovision mobile app for now.
                    </p>
					<button className="btn btn-accent mx-auto w-72">Download Now</button>
				</div>
                <div className="w-5/12">
					<img
						src={process.env.PUBLIC_URL + "img/mobileap.png"}
						className="items-end"
						alt="hero-header"
					/>
				</div>
       
                </div>
		</div>
        </section>
    );
};

export default MobileApp;